import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { AuthShell, field, label, primaryBtn } from "@/pages/Login";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const { loadMe } = useAuth();
  const [info, setInfo] = useState(null);
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/delegates/invite/${token}`).then(({ data }) => {
      setInfo(data);
      setF((p) => ({ ...p, name: data.name || "", email: data.email || "" }));
    }).catch(() => setError("Invito non valido o già utilizzato"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/delegates/accept", { token, ...f });
      await loadMe();
      toast.success("Benvenuto nel team!");
      navigate("/home");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore");
    } finally { setLoading(false); }
  };

  if (error) return <AuthShell title="Invito"><p className="text-destructive">{error}</p></AuthShell>;
  if (!info) return <AuthShell title="Invito"><p className="text-muted-foreground">Caricamento...</p></AuthShell>;

  return (
    <AuthShell title="Accetta l'invito" subtitle={`Sei stato invitato a collaborare con ${info.org_name}`}>
      <form onSubmit={submit} className="space-y-4">
        <div><label className={label}>Nome</label><input className={field} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} required /></div>
        <div><label className={label}>Email</label><input className={field} type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required /></div>
        <div><label className={label}>Password</label><input className={field} type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required minLength={6} /></div>
        <button className={primaryBtn} disabled={loading}>{loading ? "..." : "Accetta e accedi"}</button>
      </form>
    </AuthShell>
  );
}
